/* eslint-disable @eslint-react/dom/no-dangerously-set-innerhtml */
export interface HeadingProps {
    body?: string | null;
    size?: 2 | 3 | 4 | 5 | 6 | null;
    className?: string | null;
}

// Beware with this one
function Heading({ body = null, size = null, className = null }: HeadingProps) {
    const Component = `h${size || 6}` as keyof JSX.IntrinsicElements;
    return (
        <Component
            className={className ?? undefined}
            dangerouslySetInnerHTML={{ __html: body ?? '' }}
        />
    );
}

export default Heading;
